/*
 * @Author: huangzq
 * @Date: 2019-12-26 10:13:28
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-01-07 16:02:48
 * @Desc: 1
*/
<template>
  <div class="download-poster-type">
    <mk-dialog
      :visible="visible"
      title="选择下载格式"
      width="390px"
      @close="onClose"
      @open="onOpen"
    >
      <div class="content-wrapper">
        <mk-radio-group
          v-model="fileTyle"
          size="small"
        >
          <mk-radio
            v-for="item in fileTyleList"
            :key="item.type"
            :label="item.type"
          >
            {{ item.name }}
          </mk-radio>
        </mk-radio-group>
      </div>

      <div class="footer-btn">
        <mk-button-biz
          width="64px"
          font-size="13px"
          @click="onClose"
        >
          取 消
        </mk-button-biz>
        <!-- <mk-button-biz
          v-if="isBtnLoading"
          loading
          type="primary"
          width="64px"
          font-size="13px"
        /> -->
        <!-- v-else -->
        <mk-button-biz
          type="primary"
          width="64px"
          font-size="13px"
          @click="downloadPoster"
        >
          确定
        </mk-button-biz>
      </div>
    </mk-dialog>
  </div>
</template>

<script>
export default {
  name: 'DownloadPosterType',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default () {
        return {
          title: '',
          href: ''
        }
      }
    }
  },
  data () {
    return {
      // 当前选择的类型
      fileTyle: 'png',
      // 文件下载类型数据
      fileTyleList: [{
        type: 'png',
        name: 'PNG'
      }, {
        type: 'jpeg',
        name: 'JPG'
      }]
    }
  },
  methods: {
    // * 弹窗关闭事件
    onClose () {
      this.$emit('update:visible', false)
    },

    // * 弹窗打开事件
    onOpen () {
      this.fileTyle = this.fileTyleList[0].type
    },

    // * 根据类型下载海报
    downloadPoster () {
      this.util.downloadImage({
        title: this.dialogData.title,
        href: this.dialogData.cover,
        type: this.fileTyle
      })

      this.onClose()
    }
  }
}
</script>

<style lang='scss' scoped>
.download-poster-type {
  & /deep/ .mk-dialog {
    display: flex;
    align-items: center;
    justify-content: center;

    .el-dialog {
      margin-top: 0 !important;

      .el-dialog__body {
        padding: 0;

        .content-wrapper {
          padding: 42px 50px;

          .mk-radio-group {
            display: flex;
            justify-content: space-around;
          }
        }

        .footer-btn {
          line-height: 52px;
          text-align: center;
          border-top: 1px solid #e8e8e8;
        }
      }
    }
  }
}
</style>
